var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacktoTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 32,
    height: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#D3D4D5",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 16,
    cy: 16,
    r: 14
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "24.2,16.1 16,8.3 7.7,16.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3D4D5",
    d: "M11.6,24.6h-0.9V20H9.2v-0.8h4.1V20h-1.6V24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3D4D5",
    d: "M18.5,21.9c0,0.9-0.2,1.6-0.7,2c-0.4,0.5-1.1,0.7-1.9,0.7c-0.8,0-1.4-0.2-1.9-0.7 c-0.4-0.5-0.7-1.2-0.7-2.1c0-0.9,0.2-1.6,0.7-2.1c0.4-0.5,1.1-0.7,1.9-0.7c0.8,0,1.4,0.2,1.9,0.7C18.3,20.3,18.5,21,18.5,21.9z  M14.4,21.9c0,0.7,0.1,1.2,0.4,1.5c0.3,0.3,0.7,0.5,1.2,0.5c0.5,0,0.9-0.2,1.2-0.5c0.3-0.3,0.4-0.8,0.4-1.5c0-0.7-0.1-1.2-0.4-1.5 c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5C14.5,20.7,14.4,21.2,14.4,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3D4D5",
    d: "M22.8,20.8c0,0.6-0.2,1-0.6,1.3c-0.4,0.3-0.9,0.4-1.6,0.4h-0.6v2h-0.9v-5.4h1.6c0.7,0,1.2,0.1,1.5,0.4 C22.7,19.9,22.8,20.3,22.8,20.8z M20.1,21.8h0.5c0.5,0,0.8-0.1,1-0.2c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7 c-0.2-0.2-0.5-0.2-0.9-0.2h-0.6V21.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktoTop);
export default __webpack_public_path__ + "static/media/backtoTop.48f23c264da62ce9bb976f2af7de64ff.svg";
export { ForwardRef as ReactComponent };